function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import routeKeyGenerator from '@signal/router/routeKeyGenerator';
import ScrollRestorer from '@signal/utils/ScrollRestorer';
export var CLASS_NAME = 'scroll-fix';
var scrollRestorer = new ScrollRestorer(routeKeyGenerator);
export var ScrollToTop =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollToTop, _Component);

  function ScrollToTop() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollToTop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollToTop)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onBeforeUnload", function () {
      scrollRestorer.update(_this.props.location, window.scrollY);
    });

    return _this;
  }

  _createClass(ScrollToTop, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if (prevProps.location !== this.props.location) {
        return window.scrollY;
      }

      return null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Restore the scroll position of the current location on initial mount
      scrollRestorer.restore(this.props.history); // update scroll position before page is unloaded

      window.addEventListener('beforeunload', this.onBeforeUnload, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onBeforeUnload, true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, scrollYSnapshot) {
      if (scrollYSnapshot !== null) {
        // Before restoring the scroll position of the new location, two things
        // must happen:
        // 1) update the scroll position of the previous location
        scrollRestorer.update(prevProps.location, scrollYSnapshot); // 2) apply scroll "fix" to the component that is exiting

        this.scrollFix(scrollYSnapshot); // Finally, restore the scroll position of the current (new) location

        scrollRestorer.restore(this.props.history);
      }
    }
  }, {
    key: "scrollFix",
    value: function scrollFix(scrollY) {
      // find scroll fix component inside exiting route
      var content = document.querySelector("[class*=\"-exit\"] .".concat(CLASS_NAME));

      if (content) {
        // if it exists, translate it up negative scroll amount before window is
        // scrolled to 0 so that it still looks like it is scrolled
        content.style.transform = "translateY(-".concat(scrollY, "px)");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTop;
}(Component);
export var withScrollFix = function withScrollFix(Component) {
  return function (_ref) {
    var className = _ref.className,
        rest = _objectWithoutProperties(_ref, ["className"]);

    return React.createElement(Component, Object.assign({}, rest, {
      className: classnames(className, CLASS_NAME)
    }));
  };
};
export default withRouter(ScrollToTop);